import { HttpClient } from '../../httpClient'
import { throwIfNotAllowedContentType, validateHttpResponse } from '../../httpClient/utils.ts'
import { IPeriod } from './interfaces.ts'

export const getOrganizationPeriodsV2 = async (client: HttpClient, organizationId: string): Promise<IPeriod[]> => {
	const response = await client.get<IPeriod[]>(`/api/v2/organizations/${organizationId}/periods`)

	await validateHttpResponse(response)
	throwIfNotAllowedContentType(response, ['application/json'])

	return response.data
}
